<script>
	import {usuario} from '../store.js'
	import { execQuery, execRawMutation } from '../csql.js'

	//export let comprador = ''
	export let cart_handler = () => alert("Unhandled action.CartList")
	export let ultimo = false
	export let filtro = 'CERRADO'
	export let pattern = ''
	export let page = 0

	let loading=false
	let ds = []
	let eof = false
	let rpp = 10
	let formapago = { '':'NO DEFINIDO' , AC:'EFECTIVO', DT:'DEPOSITO/TRANSFERENCIA', MP:'MERCADO PAGO' }
	let toggle_info = false
	let _pattern = pattern.trim()
	let estados = [ 'ABIERTO','PENDIENTE','CANCELADO','CERRADO','FINALIZADO' ]
//	let filtro = 'CERRADO'

	function move_page(v){
		page = (!eof && v>0) ? page+1 : page // ? 
		page = (page>0 && v<0) ? page-1 : page
	}

	function buscar(){
		_pattern = pattern.trim()
	}

	function clear(){
		_pattern = ''
		pattern = ''
	}

	function ver_detalles(cartid){
		cart_handler({goto:'cartview',cartid:cartid, pattern:_pattern, page:page})
	}

	$: getAllCompras = async () =>{
		loading = true 
		let query =''
		let where = ''
		if(filtro!=='X'){
			where = ` where estado='${filtro}'`
		}else{
			where = ` where 1=1 `
		}
		if(_pattern!==''){
			where += ` and (usuario like '%${_pattern}%' OR nombre like '%${_pattern}%' OR apellido like '%${_pattern}%')`
		}
		if($usuario.tipo==='ADMIN'){
			query = `select * from invoicesh ${where} order by id desc limit ${page*rpp},${rpp}`
		}else{
			query = `select * from invoicesh where usuario='${$usuario.email}' order by id desc `
		}
		const data = await execQuery({query})
		loading= false
		let ds = data.data[0] || []
		eof = ds.length===rpp ? false : true
		if(ultimo){
			ver_detalles(ds[0].id)
		}
		return ds
	}

	//select * from invoicesh where (estado="ABIERTO" or estado="ACEPTADO" ) and usuario='${$usuario.email}' order by id desc limit 1


</script>


	<div class="container">
		<br>
		<input bind:value={pattern} style="padding:4px;margin:0" placeholder="Buscar">
		<button on:click={buscar} class="small" style="margin:0">OK</button>

		<select bind:value={filtro} style="padding:4px;margin:0">
			<option value="X">Todos</option>
			{#each estados as estado, index}
				<option value="{estado}">{estado}</option>
			{/each}
		</select>


		{#if _pattern!==''}
			<button on:click={clear}  class="small" style="margin:0">✖</button>
		{/if}
{#await getAllCompras()}
	<div class="spinner"></div>
{:then carts}
		{#each carts as cart, index}
				
			<div class="row border" style="margin-top:7px;background-color:#f7f7f7;">
				<div class="col-sm-8">#{cart.id} {cart.estado}</div>
		    	<div class="col-sm-4 text-right">{(cart.created_at||'').substr(0,10)} {(cart.created_at||'').substr(11,8)}</div>

		    <div class="col-sm-2">Email</div>
		    {#if ($usuario.tipo==='ADMIN' || cart.usuario.trim().substr(0,8)!=='__fake__')}
		    	<div class="col-sm-10">{cart.usuario} ({cart.tipo})</div>
			{:else}
		    	<div class="col-sm-10">Consumidor Final ({cart.tipo})</div>	    	
			{/if}		    
		    <div class="col-sm-2">Cliente</div>
		    <div class="col-sm-10">{cart.nombre} {cart.apellido}</div>
		    <div class="col-sm-2">
		    	<button style="margin:1px;padding:2px;" on:click={()=>ver_detalles(cart.id)}>Ver Detalles</button>

		    </div>
		    <div class="col-sm-10 text-right" >
		    	<button style="margin:1px;padding:2px;" on:click={()=>toggle_info=toggle_info===cart.id?0:cart.id}>{@html toggle_info===cart.id?'▲':'▼'}</button>
		    </div>

		  </div>
		  {#if toggle_info===cart.id}
		  	
		  	<div class="row" style="margin-bottom:15px;"> 
			    <div class="col-sm-2">CUIT/DNI</div>
			    <div class="col-sm-10">{cart.cuit}</div>

			    <div class="col-sm-2">Domicilio</div>
			    <div class="col-sm-10">{cart.domicilio}</div>

			    <div class="col-sm-2">&nbsp;</div>
			    <div class="col-sm-4">{cart.ciudad}</div>
			    <div class="col-sm-4">{cart.provincia}</div>
			    <div class="col-sm-2">{cart.codpostal}</div>

			    <div class="col-sm-2">Telefono</div>
			    <div class="col-sm-10">{cart.telefono}</div>

			    <div class="col-sm-2">F. Pago</div>
			    <div class="col-sm-8">{formapago[cart.metodopago]}
			    	{#if cart.envio_si} (ENVIO) {/if}
			    </div>
			  </div>
		  {/if}
		  {:else}
		  	<div>No hay resultados para mostrar.</div>
		{/each}
		<div class="row">
			<div class="col-sm-6 text-right"><button class="small" on:click={()=>move_page(-1)}>{@html page>0?'◀':'&nbsp;'}</button></div>
			<div class="col-sm-6"><button class="small" on:click={()=>move_page(1)}>{@html eof?'&nbsp;':'▶'}</button></div>
		</div>
{/await}
	</div>